var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#00CF5D",
    stroke: "#00CF5D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0832 9.59158L11.4082 15.9166C11.7332 16.2416 12.2582 16.2416 12.5832 15.9166L17.8332 10.6666V13.6666C17.8332 14.1249 18.2082 14.4999 18.6665 14.4999C19.1249 14.4999 19.4999 14.1249 19.4999 13.6666V8.66659C19.4999 8.20825 19.1249 7.83325 18.6665 7.83325H13.6665C13.2082 7.83325 12.8332 8.20825 12.8332 8.66659C12.8332 9.12492 13.2082 9.49992 13.6665 9.49992H16.6582L11.9999 14.1583L6.2582 8.41659C5.9332 8.09159 5.4082 8.09159 5.0832 8.41659C4.76654 8.74159 4.76654 9.27492 5.0832 9.59158Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoSuccess);
export default __webpack_public_path__ + "static/media/autoSuccess.863e4f974d616b56bb747a2dff7c0df3.svg";
export { ForwardRef as ReactComponent };